/** Which way numbers move when confirming a transfer (3046). */
export const TRANSFER_IN = 'in';
export const TRANSFER_OUT = 'out';

/**
 * The platform number with its user and trunk removed, for the PUT that
 * follows the user profile delete on a transfer OUT (3066). Clears the
 * Operator Connect profile and usage along with the trunk, as the Enabled
 * toggle does when switched off, and blanks whichever user fields the number
 * carries so the edit does not send the deleted profile back.
 */
export const clearUserAndTrunk = (platformNumber) => {
    const cleared = {
        ...platformNumber,
        trunkID: null,
        operatorConnectCallingProfileID: null,
        operatorConnectUsageID: null,
    };
    if ('user' in cleared) cleared.user = null;
    if ('platformUserID' in cleared) cleared.platformUserID = null;
    if ('userProfiles' in cleared) cleared.userProfiles = [];
    return cleared;
};

/**
 * The user profile assigned to a platform number, or null when it has none.
 * Reads the profile off the number itself when present, otherwise looks it up
 * in the company's platform users by number and platform.
 */
export const findUserProfile = (platformNumber, platformUsers = []) => {
    const { numberID, platformID } = platformNumber ?? {};
    if (!numberID) return null;

    const ownProfile = platformNumber.userProfiles?.[0];
    if (ownProfile?.platformUserID) {
        return {
            numberID: ownProfile.numberID ?? numberID,
            platformID: ownProfile.platformID ?? platformID,
            platformUserID: ownProfile.platformUserID,
        };
    }
    if (platformNumber.platformUserID) {
        return {
            numberID,
            platformID,
            platformUserID: platformNumber.platformUserID,
        };
    }

    for (const user of platformUsers) {
        const profile = user?.userProfiles?.find(
            (p) =>
                p?.numberID === numberID &&
                (!p.platformID || p.platformID === platformID),
        );
        if (profile?.platformUserID) {
            return {
                numberID,
                platformID: profile.platformID ?? platformID,
                platformUserID: profile.platformUserID,
            };
        }
    }
    return null;
};
